var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.682 0 0 2.682 0 6C0 9.318 2.682 12 6 12C9.318 12 12 9.318 12 6C12 2.682 9.318 0 6 0ZM8.58 8.58C8.346 8.814 7.968 8.814 7.734 8.58L6 6.846L4.266 8.58C4.032 8.814 3.654 8.814 3.42 8.58C3.186 8.346 3.186 7.968 3.42 7.734L5.154 6L3.42 4.266C3.186 4.032 3.186 3.654 3.42 3.42C3.654 3.186 4.032 3.186 4.266 3.42L6 5.154L7.734 3.42C7.968 3.186 8.346 3.186 8.58 3.42C8.814 3.654 8.814 4.032 8.58 4.266L6.846 6L8.58 7.734C8.808 7.962 8.808 8.346 8.58 8.58Z",
    fill: "#DD0505"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectButton);
export default __webpack_public_path__ + "static/media/rejectButton.f52be40bab18cdc55cb40900f1e5b46f.svg";
export { ForwardRef as ReactComponent };